module.exports = __webpack_public_path__ + "img/dates.584af263.svg";